<template>
    <div aria-hidden="true" aria-labelledby="modalFillInLabel" class="modal animation opacity modal-default modal-delete" id="modal-delete-vacation" role="dialog" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <strong>{{ __("Delete holiday") }}</strong>
                    <p>{{ __("Do you really want to delete the holiday?") }}</p>
                </div>

                <div class="modal-body">
                    <div class="btn-group">
                        <VButton variant="secondary" modal-target="dismiss" :label="__('Cancel')" />

                        <VButton color="danger" @onClick="cancel" modal-target="dismiss" :label="__('Delete')" />
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      coach: {
        type: Object,
        required: true
      },
      removedVacation: {
        type: Object,
        required: false
      }
    },
    methods: {
      cancel() {
        axios.delete(`/coaches/${this.coach.id}/vacations/${this.removedVacation.id}`)

        this.$emit('canceled', this.removedVacation)
      }
    }
  }
</script>
